const divider = '~';

export function convertNumberListToString(list: Array<number>): string {
    return list.join(divider);
}

export function convertStringToNumberList(str: string): Array<number>{
    if (str.length === 0) {
        return [];
    }
    return str.split(divider).map(numStr => +numStr);
}

export function convertStringListToString(list: Array<string>): string {
    return list.join(divider);
}

export function convertStringToStringList(str: string): Array<string> {
    return str.split(divider).map(numStr => numStr);
}
